'use client';

import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface StatusIndicatorProps {
  icon: ReactNode;
  text: string;
  className?: string;
}

export function StatusIndicator({ icon, text, className }: StatusIndicatorProps) {
  return (
    <div className={cn('flex items-center gap-2 text-sm text-foreground opacity-70', className)}>
      <div className="flex h-5 w-5 shrink-0 items-center justify-center">{icon}</div>
      <span className="shimmer shimmer-speed-150">{text}</span>
    </div>
  );
}

export function ThinkingDot() {
  return <span className="h-3 w-3 animate-pulse rounded-full bg-current" />;
}
